<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5 live-trade-details-card" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row class="no-gutters align-center">
            <v-col cols="12">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here..." single-line solo
                hide-details class="mt-0 mr-0"></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <v-data-table :headers="headers" :items-per-page="5" :items="Transaction">
                    <template v-slot:item.nameLink="{ item }">
                      <router-link class="text-capitalize text--ash" :to="item.nameLinkName">
                        {{ item.nameLink }}
                      </router-link>
                    </template>

                    <template v-slot:item.email="{ item }">
                      <v-tooltip top color="#000">
                        <template v-slot:activator="{ on }">
                          <v-btn plain title x-small v-on="on" @click="copyText">
                            {{ obfuscateAnyEmail(item?.email) }}
                            <v-icon x-small class="ml-1">mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ item.email }}</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:item.trxProof="{ item }">
                      <v-dialog transition="scale-transition" origin="center center" max-width="554" v-model="dialog"
                        content-class="deposit-withdraw-popup">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <img width="50px" :src="item.trxProof" />
                          </span>
                        </template>
                        <template>
                          <v-card class="rounded-0 bg-transparent pa-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'
                            ">
                            <v-btn icon color="#172233" @click="dialog = false" style="
                                position: absolute;
                                top: 1rem;
                                right: 1rem;
                                z-index: 1;
                              ">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>

                            <v-img class="white--text align-end" :src="item.trxProof"></v-img>
                          </v-card>
                        </template>
                      </v-dialog>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <v-dialog transition="scale-transition" origin="center center" max-width="985px"
                        v-model="uploadModal" content-class="upload-modal">
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex align-items-center">
                            <div>
                              <v-icon small :class="verifyIcon(item.status)"></v-icon>
                              {{ item.status }}
                            </div>
                            <div v-bind="attrs" v-on="on" :class="verifyModal(item.statusModal)">
                              <v-btn x-small icon tile style="background: #039de91a">
                                <v-icon x-small color="#039de9">mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </template>

                        <template>
                          <v-card-title class="upload-title">
                            <span>Upload Document</span>
                            <v-btn icon dark @click="uploadModal = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-card-title>
                          <ProfileVerifyModal></ProfileVerifyModal>
                        </template>
                      </v-dialog>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AssignManagerTable from "@/components/RegisteredUser/AssignManagerTable.vue";
import ProfileVerifyModal from "@/components/RegisteredUser/ProfileVerifyModal.vue";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";

export default {
  data() {
    return {
      search: "",
      uploadModal: false,
      searchManagerModal: false,
      modal: false,
      dialog: false,

      headers: [
        { text: "Date and Time", align: "start", value: "dateAndTime" },
        { text: "Name", value: "nameLink" },
        { text: "Email", value: "email" },
        { text: "Document Type", value: "documentType" },
        { text: "Proof", value: "trxProof" },
        { text: "Status", value: "status" },
      ],
      details: [
        {
          id: 1,
          para: "Payments from third parties are not accepted. The name of the sender must match the name on your trading account.",
        },
        {
          id: 2,
          para: "GIC Market accepts wire transfers in USD. Funds sent in a different currency will be converted to the deposit currency of your account. You may be charged a fee for the conversion.",
        },
        {
          id: 3,
          para: "The sending bank or correspondent bank may deduct a fee for processing a wire transfer. Demo FX does not apply any fees and will deposit to your account the net amount received.",
        },
        {
          id: 4,
          para: " The sending bank or correspondent bank may deduct a fee for processing a wire transfer. GIC Market does not apply any fees and will deposit to your account the net amount received.",
        },
        {
          id: 5,
          para: "If the transaction goes through, the funds will be posted to your trading account upon receipt by GIC Market.",
        },
      ],
      Transaction: [
        {
          dateAndTime: "25.08.20-08:32 am",
          nameLink: "Jubayer 5008",
          nameLinkName: "/talha-Ibne-Jubayer",
          email: "jubayer.nc@gmail.com",
          documentType: "Address Proof",
          trxProof: require("@/assets/trx.png"),
          status: "Approved",
          statusModal: "Verified",
        },
        {
          dateAndTime: "25.08.20-08:32 am",
          nameLink: "Jubayer 5008",
          nameLinkName: "/talha-Ibne-Jubayer",
          email: "jubayer.nc@gmail.com",
          documentType: "Address Proof",
          trxProof: require("@/assets/trx.png"),
          status: "Rejected",
        },
        {
          dateAndTime: "25.08.20-08:32 am",
          nameLink: "Jubayer 5008",
          nameLinkName: "/talha-Ibne-Jubayer",
          email: "jubayer.nc@gmail.com",
          documentType: "Address Proof",
          trxProof: require("@/assets/trx.png"),
          status: "Pending",
        },
      ],
    };
  },
  components: {
    ProfileVerifyModal,
    AssignManagerTable,
  },
  methods: {
    getColor(item) {
      return item.color;
    },
    getTextColor(item) {
      return item.class;
    },
    verifyIcon(status) {
      if (status === "Approved") return "mdi mdi-check text--green mr-1";
      else if (status === "Rejected")
        return "mdi mdi-window-close red--text mr-1";
      else return "mdi mdi-refresh mr-1 yellow--text";
    },
    verifyModal(statusModal) {
      if (statusModal === "Verified") return "d-none ml-0";
      else if (statusModal === "Decline") return "d-block ml-2";
      else return "d-block ml-2";
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    copyText() {
      const textToCopy = "jubayer.nc@gmail.com";
      navigator.clipboard.writeText(textToCopy);
    },
  },
  async mounted() {
    this.selectedSlot = "Approved";
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
};
</script>
